import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./FreeTestSeries.module.css"; // ✅ CSS Module Import
import Footer from "../Footer";
import {
  FaTachometerAlt,
  FaChartBar,
  FaRedoAlt,
  FaUserCheck,
  FaSearch,
} from "react-icons/fa";

import tests from "./dataTests/freejeetests";

import SocialSidebar from "../../components/SocialSideBar";


export default function FreeJEETestSeriesPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const testSectionRef = useRef(null);

  const scrollToTests = () => {
    if (testSectionRef.current) {
      testSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const filteredTests = tests.filter((test) =>
    test.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={styles.testSeries}>

      <SocialSidebar />
       <Breadcrumb />
      <div className={styles.testSeriesWrapper}>
        
          
        {/* Tests Section - Direct Access */}
        <section ref={testSectionRef} className={styles.testListSection}>
          <div className={styles.testListHeader}>
            <h2 className={styles.sectionHeading}>
              📚 Previous Year JEE Mains Tests ({tests.length} available)
            </h2>
            <div className={styles.searchFilterContainer}>
              <div className={styles.searchInputWrapper}>
                <FaSearch className={styles.searchIcon} />
                <input
                  type="text"
                  placeholder="Search tests(e.g 2025, Paper 1, Shift 1)"
                  className={styles.searchInput}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>
          <AnimatePresence>
            {filteredTests.length > 0 ? (
              <div className={styles.testGrid}>
                {filteredTests.map((test, index) => (
                  <motion.div
                    className={styles.testCard}
                    key={`${test.id}-${index}`}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.3, delay: index * 0.05 }}
                    whileHover={{ scale: 1.02 }}
                  >
                    <span className={styles.yearBadge}>{test.id}</span>
                    <div className={styles.testCardContent}>
                      <div className={styles.testHeader}>
                        <h3 className={styles.testTitle}>{test.title}</h3>
                      </div>
                      <p className={styles.testSubject}>
                        <span className={styles.icon}>📖</span> {test.subject}
                      </p>
                      <p className={styles.testDuration}>
                        <span className={styles.icon}>⏳</span> {test.duration}
                      </p>
                    </div>
                    <Link to={test.route} className={styles.startBtn}>
                      Proceed ➡
                    </Link>
                  </motion.div>
                ))}
              </div>
            ) : (
              <motion.div
                key="not-found"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className={styles.noResults}
              >
                <p>No tests found for your search. Try a different query.</p>
              </motion.div>
            )}
          </AnimatePresence>
        </section>
      </div>
      <Footer />
    </div>
  );
}
